export const PATCH_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_4ba215be-6ee9-4e19-8ee4-42c25732c28b/artifacts/e90d2838df2de7ec_Arjuna%20Polar%20Expedition%20Mission%20Patch.png";

export const IMG = {
  hero: "https://images.unsplash.com/photo-1765936153053-69069b1be6bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxhbnRhcmN0aWMlMjBwZW5pbnN1bGElMjBnbGFjaWVyJTIwaWNlYmVyZyUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3OTE2MjM5MDN8MA&ixlib=rb-4.1.0&q=85",
  glacier: "https://images.unsplash.com/photo-1765936153277-69e8f18db760?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxhbnRhcmN0aWMlMjBwZW5pbnN1bGElMjBnbGFjaWVyJTIwaWNlYmVyZyUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3OTE2MjM5MDN8MA&ixlib=rb-4.1.0&q=85",
  iceberg: "https://images.unsplash.com/photo-1745282398449-cc6ce4f2afda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxhbnRhcmN0aWMlMjBwZW5pbnN1bGElMjBnbGFjaWVyJTIwaWNlYmVyZyUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3OTE2MjM5MDN8MA&ixlib=rb-4.1.0&q=85",
  satEarth1: "https://images.unsplash.com/photo-1493329087152-853abc04b84b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxzYXRlbGxpdGUlMjBlYXJ0aCUyMG9ic2VydmF0aW9uJTIwdGV4dHVyZSUyMG9jZWFuJTIwaWNlfGVufDB8fHx8MTc5MTYyMzkwM3ww&ixlib=rb-4.1.0&q=85",
  satEarth2: "https://images.unsplash.com/photo-1549598685-0058b114c9d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxzYXRlbGxpdGUlMjBlYXJ0aCUyMG9ic2VydmF0aW9uJTIwdGV4dHVyZSUyMG9jZWFuJTIwaWNlfGVufDB8fHx8MTc5MTYyMzkwM3ww&ixlib=rb-4.1.0&q=85",
  vessel1: "https://images.unsplash.com/photo-1773891411696-b652241ddd2f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxwb2xhciUyMGV4cGVkaXRpb24lMjByZXNlYXJjaCUyMHZlc3NlbCUyMHNjaWVudGlzdCUyMGljZWJyZWFrZXJ8ZW58MHx8fHwxNzkxNjIzOTAzfDA&ixlib=rb-4.1.0&q=85",
  vessel2: "https://images.unsplash.com/photo-1777145110115-c0e05041bd9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxwb2xhciUyMGV4cGVkaXRpb24lMjByZXNlYXJjaCUyMHZlc3NlbCUyMHNjaWVudGlzdCUyMGljZWJyZWFrZXJ8ZW58MHx8fHwxNzkxNjIzOTAzfDA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Rationale", href: "#rationale" },
  { label: "Programme", href: "#programme" },
  { label: "Data", href: "#technology" },
  { label: "Roadmap", href: "#roadmap" },
  { label: "Study Region", href: "#study-region" },
  { label: "Partners", href: "#partners" },
  { label: "Team", href: "#team" },
];

export const PIPELINE_STEPS = [
  { num: "01", title: "Observe from orbit", desc: "Identify satellite-derived environmental indicators relevant to a focused polar research question." },
  { num: "02", title: "Prepare a geospatial baseline", desc: "Assemble and pre-process datasets for a defined Antarctic Peninsula study region." },
  { num: "03", title: "Document authorised field observations", desc: "Record location, timestamp, conditions and metadata — only within permitted expedition activity." },
  { num: "04", title: "Compare with satellite products", desc: "Align field records with satellite observations, accounting for spatial resolution and acquisition time." },
  { num: "05", title: "Quantify limitations and uncertainty", desc: "Document cloud cover, viewing geometry, temporal gaps and measurement uncertainty honestly." },
  { num: "06", title: "Build a reproducible workflow", desc: "Translate the pilot into a documented, repeatable Earth-intelligence workflow and demonstrator." },
];

export const CAPABILITIES = [
  {
    title: "Earth Observation Analytics",
    items: ["Satellite imagery interpretation", "Geospatial data integration", "Environmental change analysis", "Time-series comparison and mapping"],
  },
  {
    title: "Climate AI",
    items: ["Environmental indicators", "Climate-risk intelligence", "Geospatial data fusion", "Uncertainty-aware analytical workflows"],
  },
  {
    title: "Ocean & Maritime Intelligence",
    items: ["Regional ocean observations", "Sea-surface and ocean-colour products where appropriate", "Coastal environmental monitoring", "Integration of satellite and contextual datasets"],
  },
  {
    title: "Infrastructure & Environmental Intelligence",
    items: ["Geospatial monitoring workflows", "Environmental context for infrastructure risk", "Transferable methods for coastal and climate-sensitive regions"],
  },
];

export const WORKSTREAMS = [
  {
    code: "WS-A",
    title: "Polar Earth Observation",
    items: [
      "Identify appropriate optical and environmental satellite products",
      "Prepare regional baseline maps",
      "Assess imagery suitability and data gaps",
    ],
  },
  {
    code: "WS-B",
    title: "Satellite-to-Field Comparison",
    items: [
      "Develop a field observation protocol",
      "Record location, timestamp, conditions and metadata",
      "Compare appropriate observations and document uncertainty",
    ],
  },
  {
    code: "WS-C",
    title: "Ocean & Environmental Intelligence",
    items: [
      "Investigate suitable sea-ice, ocean-colour and surface-temperature products",
      "Assess spatial and temporal suitability for the selected study region",
      "Distinguish qualitative observations from quantitative measurements",
    ],
  },
  {
    code: "WS-D",
    title: "Geospatial AI Demonstrator",
    items: [
      "Integrate selected satellite products and field records",
      "Develop an exploratory visualisation or analytical prototype",
      "Document what the prototype can and cannot demonstrate",
    ],
  },
];

export const TECH_CARDS = [
  { code: "S2", title: "Sentinel-2", desc: "Optical imagery for suitable surface and coastal analysis." },
  { code: "S3", title: "Sentinel-3", desc: "Appropriate regional ocean and environmental products." },
  { code: "LS", title: "Landsat", desc: "Optical imagery and historical context where suitable." },
  { code: "MV", title: "MODIS & VIIRS", desc: "Relevant regional environmental products." },
  { code: "MET", title: "Meteorological & Oceanographic Data", desc: "Contextual information from appropriate sources." },
  { code: "GIS", title: "GIS & Python", desc: "Geospatial processing, analysis and reproducibility." },
  { code: "CLD", title: "Cloud Computing", desc: "Scalable data processing and demonstrator hosting." },
];

export const PHASES = [
  {
    num: "01",
    title: "Mission Definition",
    status: "IN DEVELOPMENT",
    items: ["Define a focused research question", "Identify a suitable study region", "Select satellite datasets", "Establish measurable objectives"],
  },
  {
    num: "02",
    title: "Research Partnerships",
    status: "IN DEVELOPMENT",
    items: ["Approach suitable Indian and international institutions", "Identify a qualified scientific collaborator", "Contact expedition operators", "Define required permissions and environmental assessment"],
  },
  {
    num: "03",
    title: "Pre-Expedition Development",
    status: "PLANNED",
    items: ["Build the baseline geospatial dataset", "Prepare the field protocol", "Test the analysis workflow", "Finalise equipment, funding and logistics"],
  },
  {
    num: "04",
    title: "Proposed Polar Fieldwork",
    status: "PLANNED",
    items: ["Participate in an authorised expedition", "Collect only permitted observations", "Maintain a complete field log and data provenance"],
  },
  {
    num: "05",
    title: "Post-Expedition Analysis",
    status: "PLANNED",
    items: ["Process field records", "Conduct the planned comparisons", "Evaluate uncertainty", "Publish a technical case study and demonstrator"],
  },
];

export const PARTNER_CATEGORIES = [
  "Polar research & scientific institutions",
  "Antarctic expedition operators",
  "Earth-observation & satellite-data providers",
  "Cloud & geospatial technology partners",
  "Corporate mission sponsors",
  "Scientific communications & outreach",
];

export const PROSPECTIVE_ORGS = [
  "National Centre for Polar and Ocean Research",
  "Indian universities with remote-sensing or polar-science expertise",
  "Planet Labs",
  "Airbus",
  "AWS",
  "Google Cloud",
  "Established Antarctic expedition operators",
];

export const TEAM_AREAS = [
  "Geospatial engineering",
  "Remote sensing",
  "Earth-observation data science",
  "Climate & ocean analytics",
  "Scientific field documentation",
  "Mission operations & research partnerships",
];

export const INDIA_RELEVANCE = [
  "Coastal resilience",
  "Maritime awareness",
  "Climate-risk analysis",
  "Himalayan and cryosphere research through suitable datasets and research partnerships",
  "Environmental monitoring and natural-resource management",
];
